import styled from 'styled-components'
import { blackOrange, textMuted } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'

export const HeadingBlock = styled.div`
	min-width: 0;
`

/* Explicit colors: the GlobalStyle h1/p element rules must never win here. */
export const HeadingTitle = styled.h1`
	${text.display}
	color: ${blackOrange};
	margin: 0;

	${media.phone} {
		font-size: ${fontSizes.headingLg};
	}
`

export const HeadingSubtitle = styled.p`
	${text.bodySm}
	color: ${textMuted};
	margin: 4px 0 0;
`
